import SelectableContainer from "./SelectableContainer";
import { Row, Col } from "./Flexbox";
import Text from "./Text";
import { Controller, useWatch } from "react-hook-form";

const FINISHES_MAP = {
    caja: [{label: "Plastificado", key: "lamination"}, {label: "Largo ceja", key: "glueFlap"}, {label: "Barniz", key: "coatingFinish"}, {label: "Desbarbe", key: "stripping"}],
    plana: [{label: "Plastificado", key: "lamination"}, {label: "Largo ceja", key: "glueFlap"}, {label: "Barniz", key: "coatingFinish"}, {label: "Desbarbe", key: "stripping"}],
    flexo: [{label: "Plastificado", key: "lamination"}, {label: "Largo ceja", key: "glueFlap"}]
}

const Finishes = ({theme, control}) => {

    const format = useWatch({control, name: "format"});

    const finishList = FINISHES_MAP[format?.toLowerCase()] || [];
    
    const handleToggle = (currentArray, key, onChange) => {
        const arr = currentArray || [];
        if (arr.includes(key)) {
            onChange(arr.filter((k) => k !== key));
        } else {
            onChange([...arr, key]);
        }
    }

    return (
        <Col style={{width: '100%', justifyContent: 'space-between', marginTop: 64}}>
            <Col style={{width: '100%', justifyContent: 'start', alignItems: 'start', marginTop: 16}}>
                <Text style={{marginBottom: 5}} color={theme.Black} size={15} weight={"extrabold"}>Terminados</Text>
                <Controller name="activeFinishes" control={control} render={({field: {value = [], onChange}}) => (
                    <Row style={{flexWrap: 'wrap', justifyContent: 'start', marginTop: 16}}>
                        {finishList.map((item) => {
                            return (
                                <SelectableContainer key={item.key} theme={theme} text={item.label} active={value?.includes(item.key)} onClick={() => handleToggle(value, item.key, onChange)}/>
                            )
                        })}
                    </Row>
                )}/>
            </Col>
        </Col>
    )
}

export default Finishes;